/** Prefijos i18n flowIa.<prefix>.q1 … q5 — si no hay, se usa `gen`. */

export const FLOW_IA_PREFIX_BY_SCREEN = {
  dashboard: 'dash',
  employee_portal: 'portal',
  employees: 'employees',
  employee_lifecycle: 'lifecycle',
  org_chart: 'orgchart',
  records: 'legajo',
  /** Alias UI — mismas sugerencias / fallback que legajo; la API usa `records`. */
  documents: 'legajo',
  attendance: 'attendance',
  leaves: 'leaves',
  expense_reports: 'expenses',
  expenses: 'expenses',
  personal_finance: 'finance',
  communications: 'communications',
  notifications: 'notifications',
  performance: 'eval',
  training: 'training',
  surveys: 'climate',
  awards: 'awards',
  people_intelligence: 'pi',
  reports: 'reports',
  settings: 'settings',
};

/** Pantalla enviada al backend (OpenAI/LiteLLM) — claves que entiende `flow_ia_service`. */
export const FLOW_IA_API_SCREEN_BY_UI = {
  documents: 'records',
  expenses: 'expense_reports',
};

export function resolveFlowIaApiScreen(screen) {
  const s = String(screen || 'unknown');
  return FLOW_IA_API_SCREEN_BY_UI[s] || s;
}

export function flowIaSuggestionPrefix(screen) {
  return FLOW_IA_PREFIX_BY_SCREEN[screen] || 'gen';
}
